<template>
  <div>
    <el-button @click="openAccessLogOutput" class="flex justify-center items-center w-full el-button--low-height mt-1">
      {{ $t('enterprise.access_log_output') }}
    </el-button>

    <el-dialog
      :custom-class="'el-dialog--custom'"
      v-model="isShowDialog"
      top="0"
      :destroy-on-close="false"
      :close-on-click-modal="false"
      :show-close="true"
      @close="onCloseDialog"
    >
      <el-form status-icon :label-position="'right'" label-width="220px" :model="dateModel" ref="exportDateForm">
        <div class="flex justify-evenly">
          <div class="self-center">{{ $t('export_date') }}</div>
          <div class="search-date-container">
            <el-date-picker
              :disabledDate="disabledDate"
              :clearable="false"
              v-model="dateModel.date"
              type="month"
              class="w-full"
              :editable="false"
            />
          </div>
        </div>
      </el-form>

      <template #title>
        {{ `${$t('enterprise.access_log_output')} ` }}
      </template>
      <template #footer>
        <div class="flex">
          <div class="flex-1">
            <el-button type="default" class="btn-default-cancel" @click="onCloseDialog">
              {{ $t('cancel') }}
            </el-button>
          </div>
          <div class="flex-1">
            <el-button v-loading="loading" type="primary" @click="onExportBarcode()">
              {{ $t('timetable.process') }}
            </el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script lang="ts">
import { getAccessLog } from '@/apis/systemAPI'
import { SET_HAVE_NEW_EXPORT_RECORD } from '@/store/actions'
import { EExportType } from '@/utils/enums'
import errorHandler from '@/utils/errorHandler'
import { isAfterDate } from '@/utils/utils'
import moment from 'moment'
import { Options, Vue } from 'vue-class-component'

@Options({
  name: 'AccessLogOutput',
})
export default class AccessLogOutput extends Vue {
  isShowDialog = false
  loading = false
  dateModel: Record<string, string> = { date: moment().toString() }

  openAccessLogOutput() {
    this.isShowDialog = true
  }

  disabledDate(date: Date) {
    return isAfterDate(date)
  }

  onCloseDialog() {
    this.isShowDialog = false
  }

  onChangeMonth(month: number) {
    return month.toString().length < 2 ? '0' + month.toString() : month.toString()
  }

  async onExportBarcode() {
    try {
      this.loading = true
      const month = this.onChangeMonth(new Date(this.dateModel.date).getMonth() + 1)
      const year = new Date(this.dateModel.date).getFullYear()
      await getAccessLog(`${year}-${month}`)
      this.$store.commit(SET_HAVE_NEW_EXPORT_RECORD, { exportType: EExportType.ACCESS_LOG, isHaveNew: true })
    } catch (error) {
      errorHandler(error)
    } finally {
      this.loading = false
      this.isShowDialog = false
    }
  }
}
</script>

<style lang="scss" scoped>
.search-date-container {
  :deep(.el-date-editor.el-input) {
    width: 100% !important;
    height: auto;
  }
}
</style>
